var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialCare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social-care",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.208,
    height: 55.428,
    viewBox: "0 0 55.208 55.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(0 30.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22338",
    "data-name": "Path 22338",
    d: "M14.158,301.912H2.207a1.188,1.188,0,0,1-1.191-1.185v-9.856a1.183,1.183,0,0,1,.46-.935l9.926-7.682A12.293,12.293,0,0,1,18.89,279.7H35.106a4.486,4.486,0,0,1,4.492,4.47,4.429,4.429,0,0,1-.309,1.628l.065-.055,9.13-8.036a4.808,4.808,0,0,1,6.471.2h0a4.295,4.295,0,0,1-.169,6.254l-11.973,10.7a10.009,10.009,0,0,1-6.678,2.546H20.993l-6.151,4.3A1.2,1.2,0,0,1,14.158,301.912ZM3.4,299.542H13.781l6.151-4.3a1.2,1.2,0,0,1,.684-.215H36.135a7.624,7.624,0,0,0,5.087-1.939l11.973-10.7a1.933,1.933,0,0,0,.076-2.815h0a2.414,2.414,0,0,0-3.209-.1l-9.13,8.036a4.5,4.5,0,0,1-2.977,1.122H23.744a1.185,1.185,0,1,1,0-2.37H35.106a2.1,2.1,0,1,0,0-4.2H18.89a9.893,9.893,0,0,0-6.026,2.057L3.4,291.45v8.092Z",
    transform: "translate(-1.016 -276.548)",
    fill: "#fff"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22339",
    "data-name": "Path 22339",
    d: "M159.99,13.134a7.345,7.345,0,1,0-9.027,0,11.977,11.977,0,0,0-7.623,11.144v1.548a1.185,1.185,0,0,0,1.185,1.185h21.9a1.185,1.185,0,0,0,1.185-1.185V24.278A11.977,11.977,0,0,0,159.99,13.134ZM155.476,2.37A4.975,4.975,0,1,1,150.5,7.345,4.981,4.981,0,0,1,155.476,2.37Zm9.766,22.27H145.71a9.768,9.768,0,1,1,19.533,0Z",
    transform: "translate(-127.872)",
    fill: "#61ce65"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialCare);
export default __webpack_public_path__ + "static/media/social-care.e2941dbdc99d153db1b34588429da386.svg";
export { ForwardRef as ReactComponent };